import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ing_isc',
  templateUrl: './ing_isc.component.html',
  styleUrls: ['./ing_isc.component.css']
})
export class Ing_iscComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
